import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import TrackShipmentPage from '../pages/TrackShipment';
import LoginPage from '../pages/Login';
import ShipmentsPage from '../pages/Shipments';
import AdminPage from '../pages/Admin';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/track-shipment" element={<TrackShipmentPage />} />
    <Route path="/TrackShipment" element={<TrackShipmentPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/shipments" element={<ShipmentsPage />} />
    <Route path="/admin" element={<AdminPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
